/**
 * Defines the feature switches, that en- or disable a certain kind of functionality in the app.
 */
export enum Feature {
  /**
   * LegalEntity/Organization-grouping:
   * - Adding an organization to a group (incl. creating new groups)
   * - Display of organization group on product
   * - Adding advanced search filter for group filtering
   */
  LE_GROUPING = 'LE_GROUPING',
  SHOW_SUPPLIERREFERENCE = 'SHOW_SUPPLIERREFERENCE',
  EDIT_SUPPLIERREFERENCE = 'EDIT_SUPPLIERREFERENCE'
}
